import React from 'react';
import { useAuth } from './context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

function AdminRoute() {
    const { user } = useAuth();

    // La condición ahora es doble:
    // 1. ¿Hay un usuario?
    // 2. ¿El rol de ese usuario es 'admin'?
    if (!user || user.rol !== 'admin') {
        // Si no cumple, lo redirigimos al dashboard normal, no al login.
        return <Navigate to="/dashboard" />;
    }

    // Si cumple ambas condiciones, le damos acceso a la página de admin.
    return <Outlet />;
}

export default AdminRoute;